import { styled } from "@mui/material";
import TertiaryButton from "../../generated/TertiaryButton";

const MobileUswfButton = styled(TertiaryButton)({
  minWidth: 220,
  paddingLeft: 16,
  paddingRight: 16,
});

export default MobileUswfButton;
